import {
  Box,
  Card,
  CardContent,
  Container,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import EmailIcon from "@mui/icons-material/Email";
import ScheduleIcon from "@mui/icons-material/Schedule";

export default function ContactPage() {
  const { t } = useTranslation("pages-core");
  return (
    <Container maxWidth="md" sx={{ py: { xs: 5, md: 8 } }}>
      <Stack spacing={1} sx={{ mb: 5 }}>
        <Typography
          variant="overline"
          color="secondary.main"
          sx={{ fontWeight: 500, letterSpacing: "0.08em" }}
        >
          {t("ContactPage.eyebrow")}
        </Typography>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 500 }}>
          {t("ContactPage.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600 }}>
          {t("ContactPage.intro")}
        </Typography>
      </Stack>

      <Stack spacing={3} sx={{ mb: 5 }}>
        <Card variant="outlined">
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <EmailIcon color="secondary" />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 0.5 }}>
                  {t("ContactPage.emailHeading")}
                </Typography>
                <Link
                  href="mailto:support@career-forge.org"
                  variant="body1"
                  underline="hover"
                  sx={{ color: "text.primary" }}
                >
                  {t("ContactPage.supportEmail")}
                </Link>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  {t("ContactPage.emailDescription")}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        <Card variant="outlined">
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <ScheduleIcon color="secondary" />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 0.5 }}>
                  {t("ContactPage.responseTimesHeading")}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t("ContactPage.responseTimeStandard")}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t("ContactPage.responseTimeBilling")}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

      </Stack>

      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 2,
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          <Trans
            i18nKey="ContactPage.legalNotice"
            t={t}
            components={[
              <Link key="terms" component={RouterLink} to="/terms" />,
              <Link key="privacy" component={RouterLink} to="/privacy" />,
              <Link key="refunds" component={RouterLink} to="/refunds" />,
            ]}
          />
        </Typography>
      </Box>
    </Container>
  );
}
